export default __webpack_public_path__ + "static/media/Wolf's Tunic of the Howling Wind.ad3de7ad.jpg";